import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import CustomTable from '../CustomTable'
import { fetchDeletedSites } from '../../Manage/actions'
import useCheckIsMobileScreen from '../../hooks/checkMobileScreen'
import styles from './DeletedTable.module.css'

const DeletedTable = ({ onRestoreDeleted, onPermanentlyDelete }) => {
  const dispatch = useDispatch()
  const { deletedSites, fetchingDeletedSites } = useSelector((state) => state.manage)
  const { isMobile } = useCheckIsMobileScreen()

  useEffect(() => {
    dispatch(fetchDeletedSites())
  }, [dispatch])

  const headers = [
    { key: 'status', text: 'Status', icon: '', cellType: 'status' },
    { key: 'domain', text: 'Link', icon: '', cellType: 'domain' },
    { key: 'lastModified', text: 'Deleted', icon: '', cellType: 'lastModified' },
    { key: 'actions', text: 'Actions', icon: '', cellType: 'actions' }
  ]

  const calculateDaysRemaining = (deletedDate) => {
    const deleted = new Date(deletedDate)
    const now = new Date()
    const daysSinceDeleted = Math.floor((now - deleted) / (1000 * 60 * 60 * 24))
    const daysRemaining = Math.max(0, 3 - daysSinceDeleted)
    return daysRemaining
  }

  const data = deletedSites.map((site) => {
    const deletedDate = site.trashedAt
    const daysRemaining = calculateDaysRemaining(deletedDate)

    return {
      status: {
        status: 'deleted',
        text: 'Deleted'
      },
      domain: {
        label: site.subdomain,
        href: `https://${site.subdomain}`,
        site: site,
        handlePreviewClick: null,
        disabled: true,
        trialAccount: false,
        isTransferRequestLink: false,
        onShare: null,
        daysRemaining: daysRemaining,
        status: 'deleted',
        statusText: 'Deleted'
      },
      lastModified: new Date(deletedDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: '2-digit'
      }),
      actions: [
        {
          icon: '/assets/icons/trash.svg',
          tooltip: 'Permanently Delete',
          onClick: () => onPermanentlyDelete(site.subdomain),
          label: isMobile ? 'Delete' : undefined
        },
        {
          icon: '/assets/icons/cloud-upload-restore.svg',
          tooltip: 'Restore',
          onClick: () => onRestoreDeleted(site.subdomain),
          label: isMobile ? 'Restore' : undefined
        }
      ]
    }
  })

  return (
    <div className="box-100-scrolless">
      {deletedSites.length > 0 ? (
        <>
          <div className={styles.headerSection}>
            <h4 className={styles.title}>Deleted Projects</h4>
            <p className={styles.warningText}>Deleted projects are automatically removed after 3 days.</p>
          </div>
          <CustomTable
            title=""
            data={data}
            headers={headers}
            badge={''}
            headerButtons={[]}
            loading={fetchingDeletedSites}
          />
        </>
      ) : (
        <div className="table-empty">
          <div>
            <span className="light-grey bold">No deleted projects</span>
          </div>
          <div className="mt-1 text-sm light-grey">Deleted projects will appear here.</div>
        </div>
      )}
    </div>
  )
}

export default DeletedTable
